const brightYellow300Color = '#f3ca00';

export default brightYellow300Color;
